import Model from "~~/package/mapper/Model";
import {createModel} from "~~/package/utils/ModelUtil";

export class ProSkillAssureAnswerCodeSubmitModel extends Model {
    constructor(
        public isLastQuestion: boolean = true,
        public output: string = "string",
        public submissionAnswerList: string[] = [],
        public score: number | undefined = undefined
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAnswerCodeSubmitModel>): ProSkillAssureAnswerCodeSubmitModel {
        return createModel<ProSkillAssureAnswerCodeSubmitModel>(ProSkillAssureAnswerCodeSubmitModel, {
            ...model
        });
    }
}
